import { render, staticRenderFns } from "./PrintAreaIcons.vue?vue&type=template&id=0fd88775&scoped=true"
import script from "./PrintAreaIcons.vue?vue&type=script&lang=js"
export * from "./PrintAreaIcons.vue?vue&type=script&lang=js"
import style0 from "./PrintAreaIcons.vue?vue&type=style&index=0&id=0fd88775&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd88775",
  null
  
)

export default component.exports